// Copyright (c) 2021 WiseTime. All rights reserved.

import React, { useMemo } from "react"
import { useSelector } from "react-redux"
import { convertMonthDateToDateTime, getMonthDatesForHalfYear, TimelineMonth } from "../dateTime"
import * as TrashedTimeSlice from "../trash/slice"
import DateTabTrash from "./DateTabTrash"
import { DateTabsWrapper } from "../../shared/styles"

const DateTabsTrash = (): React.ReactElement => {
  const activeMonth = useSelector(TrashedTimeSlice.selectActiveTrashMonth)
  const activeMonthTabs = useMemo(() => getMonthDatesForHalfYear(convertMonthDateToDateTime(activeMonth)), [activeMonth])
  return (
    <DateTabsWrapper>
      {activeMonthTabs.map((timelineMonth: TimelineMonth) => (
        <DateTabTrash
          key={timelineMonth.toString()}
          timelineMonth={timelineMonth}
          isActive={activeMonth === timelineMonth}
        />
      ))}
    </DateTabsWrapper>
  )
}

export default DateTabsTrash
